import { useParams } from 'react-router-dom';
import { type SafeParseSuccess, type ZodType } from 'zod';

export function useAppParams<Type extends ZodType<Record<string, string>>>(
  schema: Type,
): SafeParseSuccess<Type['_type']>['data'] | null {
  const routerParams = useParams();
  const validatedSchema = schema.safeParse(routerParams);

  return validatedSchema.success ? validatedSchema.data : null;
}
